export const compositionFragmentConfigSymbol = Symbol('compositionFragmentConfig');

//# sourceMappingURL=composition.js.map